import { useLocation } from "react-router";

const mode = "live";
// Per-tenant runtime config: deploy-frontend.yml writes /env.js next to index.html
// in the tenant's S3 prefix, which sets window.__ENV__ before the bundle loads.
// When absent (local dev, legacy per-branch builds) the build-time values below apply.
const runtimeEnv: Record<string, string> = (typeof window !== "undefined" && (window as any).__ENV__) || {};
const site = runtimeEnv.TENANT || process.env.REACT_APP_TENANT || "psb3";
// Tenant-agnostic builds (build-frontends.yml sets REACT_APP_RUNTIME_TENANT) must
// get the tenant from env.js — failing loudly beats serving another tenant's app.
if (process.env.REACT_APP_RUNTIME_TENANT && !runtimeEnv.TENANT) {
    throw new Error("env.js missing or invalid: no tenant configured for this deployment");
}
const isbat  = "isbat"
const isbatTesting = "isbat-testing"
const tuningfork = "tuningfork"
const isbatTestingSiteUrl = "https://"+ isbatTesting + ".edusquares.com/"
const baseUrl = runtimeEnv.TUNINGFORK_URL || process.env.REACT_APP_TUNINGFORK_URL || `https://${site}.edusquares.com/`;
// const baseUrl = `http://localhost:8080/edusquares/`;
// const baseUrl = `https://ifacet.edusquares.com/`;

// Whether this tenant still has a legacy Java (tuningfork) backend behind
// `baseUrl`. Tenants migrated off it — currently the SynerGen cloud — get
// JAVA_BACKEND: "none" in their env.js; everyone else keeps the Java default.
// This is an explicit opt-out on purpose: env.js never emits TUNINGFORK_URL for
// ANY tenant, so inferring "no Java" from a missing URL would silently flip the
// whole fleet onto the node paths.
const hasJavaBackend = (runtimeEnv.JAVA_BACKEND || "java") !== "none";

const studyResource = 29
const token = localStorage.getItem("login_token");
const loggedin_userId = localStorage.getItem("userId");

const nodeSiteUrl = runtimeEnv.NODE_API || process.env.REACT_APP_NODE_API || `https://${site}-node.edusquares.com/api/`;
// Production ilearn lives at {tenant}.ilearn.edusquares.com — NOT {tenant}.edusquares.com
// (that subdomain is the legacy Java tuningfork app). REACT_APP_ILEARN_URL overrides
// for local dev (typically http://localhost:3001).
const ilearnUrl = process.env.REACT_APP_ILEARN_URL || `https://${site}.ilearn.edusquares.com/`;
// const nodeSiteUrl = `http://localhost:8080/api/`;

// Authentication backend selection ('java' or 'node')
const authBackend = process.env.REACT_APP_AUTH_BACKEND || 'java';
// Default backend for data operations ('java' or 'node')
const defaultBackend = process.env.REACT_APP_DEFAULT_BACKEND || 'java';
// For node backend, use nodeSiteUrl with v1 prefix; for java, use baseUrl
const authBaseUrl = authBackend === 'node' ? nodeSiteUrl + 'v1/' : baseUrl;

// const siteUrl = "http://localhost:8080/tuningfork/";
//const siteUrl = "https://erp.nttftrg.com/";
const Config = {
    customer: site,
    site: site,
    versionName: '1.0.1',
    siteMode:  mode,
    baseUrl :  baseUrl,
    hasJavaBackend,
    nodeSiteUrl,
    ilearnUrl,
    authBackend,
    authBaseUrl,
    defaultBackend,
    tenantDisplayName: site.toUpperCase(),

    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "",

    CONNECTION_ERROR_MSG: "The server is taking too long to respond or something is wrong with your internet connection. Please try again later.",
    /**
     * Maximum number of records to fetch from the academic details API
     * Used across all director dashboard views for data aggregation
     */
    ACADEMIC_DETAILS_LIMIT: 10000
}
export default Config;
